var map = {
	"./Assistance.svg": "8d76",
	"./Disability.svg": "5303",
	"./Senior.svg": "261e",
	"./arrow-green.png": "7a5e",
	"./brought-to-you-desktop-en.png": "7618",
	"./brought-to-you-desktop-fr.png": "e4bc",
	"./brought-to-you-mobile-en.png": "eb1a",
	"./brought-to-you-mobile-fr.png": "999f",
	"./difference.jpg": "0e0b",
	"./email-icon.png": "7398",
	"./facebook-icon.svg": "0053",
	"./family-circled.png": "cbe6",
	"./fish-can.png": "5fbc",
	"./food.jpg": "212b",
	"./fruits-circled.png": "c415",
	"./green-diamond.png": "0f57",
	"./heart-circled.png": "8e35",
	"./heart-hands.png": "ab78",
	"./hero-image-old.jpg": "97c5",
	"./hero-image.jpg": "e294",
	"./instagram-icon.svg": "b5a2",
	"./linkedin-icon.svg": "d4a2",
	"./logo-fr.jpg": "58b7",
	"./logo.svg": "1ae4",
	"./manulife-banner-icon.png": "915f",
	"./manulife-banner-logo-fr.png": "2c5d",
	"./manulife-banner-logo-fr.svg": "ddd8",
	"./manulife-banner-logo.png": "166f",
	"./manulife-banner-logo.svg": "585d",
	"./manulife-bg.jpg": "a125",
	"./manulife-blue-text.png": "4c94",
	"./manulife-icon.png": "14f8",
	"./manulife-logo-big.png": "f175",
	"./manulife-logo.png": "0af3",
	"./manulife-men-on-laptop.png": "b165",
	"./manulife-text.png": "d0a2",
	"./more-food.jpg": "449b",
	"./phone-icon.png": "503a",
	"./play.svg": "cc2e",
	"./post.jpg": "1d0a",
	"./savings-pig.png": "66cf",
	"./sharing-bg.png": "c6fe",
	"./twitter-icon.svg": "e147",
	"./video-thumbnail.jpg": "7004",
	"./youtube-icon.svg": "9364"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";